"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgSmileFaceOutline = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M12.069 14.984c.922-.034 1.788-.448 2.28-1.052a1 1 0 111.551 1.262c-.902 1.11-2.34 1.736-3.757 1.789-1.437.053-2.97-.483-3.972-1.848a1 1 0 011.612-1.184c.54.736 1.384 1.067 2.286 1.033z' }),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M12 20a8 8 0 100-16 8 8 0 000 16zm0 2c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z' }),
    react_1.default.createElement("path", { d: 'M10 10.688a1 1 0 11-2 0 1 1 0 012 0zM16 10.688a1 1 0 11-2 0 1 1 0 012 0z' }))); };
exports.default = SvgSmileFaceOutline;
//# sourceMappingURL=SmileFaceOutline.js.map